import { InputAdornmentButton } from '@cian/ui-kit';
import { FDealType } from '../../../../../../packages/JsonQuery';
import { useSelector } from 'react-redux';
import { selectDealType } from 'shared/selectors/jsonQuery';
import { selectHasDistricts, selectHasRegionalDistricts, selectHasUnderground } from 'shared/selectors/location';
import { DistrictsModalContainer } from '../ModalContainer';
import { useAppDispatch, useModalState } from 'shared/hooks';
import { useCallback } from 'react';
import { loadDistrictsTree } from 'shared/thunks/geo/districtsSwitcher';
import { trackOpenDistrictsModalEvent } from './tracking';
import { trackQuickFilterClick } from 'shared/utils/analytics';

export const DistrictsPopupButtonContainer = () => {
  const dispatch = useAppDispatch();
  const dealType = useSelector(selectDealType);
  const hasUnderground = useSelector(selectHasUnderground);
  const hasDistricts = useSelector(selectHasDistricts);
  const hasRegionalDistricts = useSelector(selectHasRegionalDistricts);

  const { opened, onClose, onOpen } = useModalState();

  const handleOpen = useCallback(() => {
    onOpen();
    dispatch(loadDistrictsTree());
    trackQuickFilterClick('district');
    trackOpenDistrictsModalEvent();
  }, [dispatch, onOpen]);

  if ((dealType === FDealType.RentDaily && hasUnderground) || !hasDistricts || hasRegionalDistricts) {
    return null;
  }

  return (
    <>
      <InputAdornmentButton type="button" onClick={handleOpen} data-name="DistrictsPopupButtonContainer">
        Район
      </InputAdornmentButton>
      {opened && <DistrictsModalContainer onModalClose={onClose} />}
    </>
  );
};
